import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { ProductService } from './service/ProductService';

export default function MoveTheTable( {data}) {
    const [products, setProducts] = useState([]);


    //var data = []

    useEffect(()=>{


        console.log( "Se esta cambiando el data")

        if ( data?.length > 0)
        {
            console.log( "Data = " , data[0] )
        }

    } ,[data])


    return (
        <div className="card">
            
            <DataTable stripedRows value={data} tableStyle={{ minWidth: '50rem' }}>
                <Column field="numtel" header="NumTel"></Column>
                {/* <Column field="nombre" header="Nombre"></Column> */}
                <Column field="nombrebaseactual" header="NombreBaseTelcel"></Column>
                        
            </DataTable>
        </div>
    )

}